module.exports = __webpack_public_path__ + "static/media/ac_ai_shan.799e9568.png";